import type { TrComponentColors } from '@core/plugins/vuetify/colors/componentsColors.interface'
import { ClicSanteColors } from '@core/config/themes/colors'

export const ClicSanteThemeComponentColors: TrComponentColors = {
  // Action Button
  'action-btn-bg': ClicSanteColors.blue['900'],
  'action-btn-text': ClicSanteColors.blue['100'],
  'action-btn-secondary-bg': ClicSanteColors.white,
  'action-btn-secondary-text': ClicSanteColors.blue['500'],
  'action-btn-secondary-border': ClicSanteColors.grey['500'],

  //   Background
  'primary-bg': ClicSanteColors.white,
  'secondary-bg': ClicSanteColors.grey['100']
}
